import React from 'react'
import { Container, Image, Header } from 'semantic-ui-react';
import NoSearchFoundImage from '../../images/grafix-banner/gfx-no-results.svg';

class NothingToShow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return <Container fluid className="pad_40">
            <Image src={NoSearchFoundImage} size='small' centered={true} style={this.props.imgStyle ? this.props.imgStyle : {}} />
            <Header as='h3' icon textAlign='center'>
                <Header.Content >
                    Nothing to show!
                <br />  <br />
                </Header.Content>
            </Header>
        </Container>
    }
}

export default NothingToShow;


